module.exports = __webpack_public_path__ + "static/the_rda_way-5a105a43d5e1ef710b61dbe0179c11ab.svg";